import React from "react"
import { graphql } from "gatsby"

import "./talks-schedule.css"

import EventList from "../components/eventList"

export default ({ data }) => (
	<EventList
		type="Talks & Schedule"
		meta={{
			title: "Talks & Schedule",
			description:
				"Check out the awesome Java and JavaScript talks at Accento on Sep 24th 2019!",
			keywords: `Java JavaScript talks Karlsruhe`,
			path: "/talks",
		}}
		snippetId="talks-intro"
		events={data.talks.edges}
		extra={{
			title: "Lightning Talks",
			imageSlug: "lightning",
			snippetId: "lightning-talks",
		}}
	/>
)

export const query = graphql`
	query {
		talks: allMarkdownRemark(
			sort: { fields: frontmatter___priority, order: ASC }
			filter: { fields: { collection: { eq: "talks" } } }
		) {
			...AllEventEdges
		}
	}
`
